import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import ErrorIcon from '@mui/icons-material/Error';
import { Box } from '@mui/material';

import { fileUploadErrorsSelector } from '@store/features/fileUploadState/selectors';

import './styles.scss';

const FileUploadErrors: FC = () => {
  const fileUploadErrors = useSelector(fileUploadErrorsSelector);
  const { t } = useTranslation();

  if (!fileUploadErrors.length) {
    return null;
  }

  return (
    <Box className="file-upload-errors__wrapper">
      <p className="file-upload-errors__title">
        <ErrorIcon color="error" />
        <span>{t('errors.uploadFileError')}</span>
      </p>
      {fileUploadErrors.map((item: string) => (
        <p className="file-upload-errors__text">{item}</p>
      ))}
    </Box>
  );
};
export default FileUploadErrors;
